import mutations from './mutations';
import actions from './actions';
import getters from './getters';

const state = {
    purchase: {
      date: new Date().toISOString(),
        supplier_id: "",
        invoice_number: "",
        status: "",
        payment_mode_id: "",
        payment_note: "",
        total: 0,
        paid_amount: 0,
        items: [
          {
            product_id: "",
            quantity: 1,
            price: 0,
            tax_id: "",
            discount: 0
          }
        ],
    },
   purchaseList: [],
   suppliers: [],
    defaultPaymentModeId: '',
    statuses: [
        { label: "Completed", value: "completed" },
        { label: "Pending", value: "pending" }
      ]
   
};

const purchase = {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}

export default purchase;